import moment from "moment";
import {
  TipDetails,
  TipFilter,
  TipStatus,
  WorkerStatus,
  TipDisplayStatus,
} from "model/Tip";

export const getFilteredTips = (
  tips: TipDetails[],
  selectedFilter: TipFilter,
): TipDetails[] => {
  let filtered: TipDetails[];

  switch (selectedFilter) {
    case TipFilter.Saved:
      filtered = tips.filter((tip) => tip.status === TipStatus.Saved);
      break;
    case TipFilter.ReadyToPayout:
      filtered = tips.filter((tip) => tip.status === TipStatus.Done);
      break;
    case TipFilter.PaidOut:
      filtered = tips.filter(
        (tip) =>
          tip.status === TipStatus.Closed ||
          tip.status === TipStatus.ClosedManually,
      );
      break;
    default:
      filtered = tips;
  }

  return filtered.sort((a, b) => moment(a.date).diff(moment(b.date)));
};

export const getTipDisplayStatus = (tip: TipDetails): TipDisplayStatus => {
  const workers = tip.workers ?? [];
  const workerStatuses = workers.map((worker) => worker.status);

  if (tip.status === TipStatus.ClosedManually) {
    return TipDisplayStatus.PaidManually;
  }

  if (tip.status === TipStatus.Closed) {
    return TipDisplayStatus.Paid;
  }

  if (tip.status === TipStatus.Done) {
    const totalWorkers = workers.length;

    const paidWorkers = workerStatuses.filter(
      (status) => status === WorkerStatus.Paid,
    ).length;
    const failedWorkers = workerStatuses.filter(
      (status) => status === WorkerStatus.Failed,
    ).length;
    const createdWorkers = workerStatuses.filter(
      (status) => status === WorkerStatus.Created,
    ).length;
    const nullWorkers = workerStatuses.filter(
      (status) => status === null || status === WorkerStatus.null,
    ).length;

    if (paidWorkers === totalWorkers && failedWorkers === 0) {
      return TipDisplayStatus.Paid;
    }

    if (failedWorkers === totalWorkers && paidWorkers === 0) {
      return TipDisplayStatus.Failed;
    }

    if (paidWorkers > 0 && failedWorkers > 0) {
      return TipDisplayStatus.PartlyPaid;
    }

    if (
      createdWorkers > 0 ||
      (nullWorkers > 0 && paidWorkers + failedWorkers > 0)
    ) {
      return TipDisplayStatus.PayoutInProgress;
    }

    return TipDisplayStatus.ReadyToPayout;
  }

  if (tip.status === TipStatus.Saved) {
    return TipDisplayStatus.Saved;
  }

  if (tip.status === TipStatus.Created) {
    return TipDisplayStatus.Created;
  }

  return TipDisplayStatus.Created;
};
